// Hero.jsx
import FadeInOnScroll from "./FadeInOnScroll"; // 名字随便，但首字母要大写
export default function Hero() {
  return (
    <section className="relative text-center text-textPrimary">
      {/* 背景视频 */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src="/home-video2.mp4"
        autoPlay
        muted
        loop
        playsInline
      />

      {/* 遮罩层让文字更清晰 */}
      <div className="absolute inset-0 bg-black/70" />

      {/* 内容层 */}
      <div className="relative z-10 py-48 px-4">
        <FadeInOnScroll>
          {/* 主标题 */}
          <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-6 text-white">
            POWERING THE {/* 只在手机端显示的换行 */}
            <br className="block md:hidden" />
            NEW ERA WITH
            <br />
            <span className="text-[#c9a7ff]">
              STATE-OF-THE-ART TAILORED SOLUTIONS
            </span>
          </h1>

          {/* 副标题 */}
          <p className="text-base md:text-lg text-gray-200 max-w-2xl mx-auto mb-8">
            Driving digital transformation through intelligent, scalable, <br />
            and future-ready ecosystems.
          </p>
        </FadeInOnScroll>
      </div>
    </section>
  );
}
